import * as contentful from 'contentful';

const client = contentful.createClient({
    space: "t2sxt2nwpxzz",
    accessToken: "_J7ePKtzQxnUXyvGrocYkXofVizTleW32hWYWeNtKJs",

});

export default client;